import { ApiError, handleApiError } from '@/handleApiError'
import api from '@/modules/subsidiary/api'
import { PAGE_SIZE } from '@/types'
import { Subsidiary } from '@/types/index'
import { concat } from 'lodash-es'
import { ref } from 'vue'

export function useSubsidiarySearch() {
  const subsidiaries = ref<Subsidiary[]>([])
  const loading = ref(false)
  let totalCount = 0
  let currentKeyword: string | undefined = undefined
  let page = 0
  let hasNext = false

  async function searchSubsidiaries(keyword?: string) {
    loading.value = true
    currentKeyword = keyword?.trim() ?? undefined
    page = 0

    return api
      .subsidiariesSearch(0, PAGE_SIZE, currentKeyword)
      .then(({ data }) => {
        subsidiaries.value = data.items
        totalCount = data.totalCount
        hasNext = totalCount > subsidiaries.value.length
      })
      .catch((error: ApiError) =>
        handleApiError(error, undefined, {
          errorCode: 403,
          logError: false,
          appearance: 'NONE'
        })
      )
      .finally(() => {
        loading.value = false
      })
  }

  async function loadNextPage() {
    if (hasNext && !loading.value) {
      loading.value = true
      page++

      return api
        .subsidiariesSearch(page, PAGE_SIZE, currentKeyword)
        .then(({ data }) => {
          subsidiaries.value = concat(subsidiaries.value, data.items)
          hasNext = totalCount > subsidiaries.value.length
        })
        .catch((error: ApiError) => {
          subsidiaries.value = []
          page = 0
          hasNext = false
          handleApiError(error, undefined, {
            errorCode: 403,
            logError: false,
            appearance: 'NONE'
          })
        })
        .finally(() => {
          loading.value = false
        })
    }
  }

  async function clearSubsidiaries() {
    subsidiaries.value = []
  }

  return { subsidiaries, loading, searchSubsidiaries, clearSubsidiaries, loadNextPage }
}
